// extracted by css-extract-rspack-plugin
export default {"disabled":"dropdown-menu__disabled--KM14p","disabledReason":"dropdown-menu__disabledReason--IUtIa"};